// extracted by mini-css-extract-plugin
export var activeDot = "_2n-c";
export var buttonContainer = "_2n-9";
export var channelButton = "_2n-a";
export var clickable = "_2n-d";
export var content = "_2n-0";
export var contentFull = "_2n-2";
export var contentThird = "_2n-1";
export var contentWrapper = "_2n-7";
export var description = "_2n-5";
export var heightShort = "_2n-f";
export var image = "_2n-3";
export var imageContainer = "_2n-4";
export var selectButton = "_2n-e";
export var spinnerContainer = "_2n-b";
export var titleContent = "_2n-8";
export var titleWrapper = "_2n-6";